import React from 'react';
import './modernAlert.css'

/*
* Para Usar o Alert com callback, passar tbm um icone, importando em public/estilo.css
* Cores: success / danger / warning
*/


const ModernAlert = props => {
    return (
        props.msg ? (
            <div className={`main-alert fade-in ${props.color}`}>
                <div className='text-alert'>
                    {typeof props.msg === 'object' ? (
                        props.msg.map((d, i) => {
                            return <span key={i}>{d}<br /></span>
                        })
                    ) : <span>{props.msg}</span> }
                    

                </div>

                {props.callback && props.callbackIcon ? (
                    <div className='callback-alert'>
                        <div className={`callback-alert-icon ${props.callbackIcon}`} onClick={() => props.callback()} />
                    </div>

                ) : null}

            </div>
        ) : null
    )
}

export default ModernAlert